import { styled } from '@hub-la/design-system';

let _ = t => t,
  _t,
  _t2;
const LoaderWrapper = styled('div')(_t || (_t = _`
  width: 100%;
  text-align: center;
  height: 408px;
  position: relative;
`));
const ImageWrapper = styled('div')(_t2 || (_t2 = _`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`));

export { ImageWrapper, LoaderWrapper };
